import { DefaultTheme, rgba } from '../theme';
import { ColorPaletteBlue } from '../theme.palette';

export const CSS = {
	container: 'c-SwitchInput',
	label: 'c-SwitchInput__label',
	input: 'c-SwitchInput__input',
	slider: 'c-SwitchInput__slider',
};

const SWITCH_WIDTH = DefaultTheme.spacingFactor * 9;
const SWITCH_HEIGHT = DefaultTheme.spacingFactor * 3;

const SLIDER_WIDTH = 20;

export const Style = {
	[CSS.container]: {
		display: 'flex',
	},
	[CSS.label]: {
		position: 'relative',
		display: 'inline-block',
		width: `${SWITCH_WIDTH}px`,
		height: `${SWITCH_HEIGHT}px`,
		margin: '5px',
	},
	[CSS.input]: {
		opacity: 0,
		[`&:checked + .${CSS.slider}`]: {
			'background-color': rgba(ColorPaletteBlue.C700, 0.5),
		},
		[`&:checked + .${CSS.slider}:before`]: {
			transform: `translateX(${SWITCH_WIDTH - SLIDER_WIDTH}px)`,
			'background-color': DefaultTheme.color.primary,
		},
		[`&:focus + .${CSS.slider}`]: {
			outline: `1px solid ${DefaultTheme.color.primary}`,
		},
	},
	[CSS.slider]: {
		position: 'absolute',
		cursor: 'pointer',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		'background-color': DefaultTheme.font.color.disabled,
		transition: '.4s',
		'border-radius': `${SWITCH_WIDTH}px`,
		'&:before': {
			position: 'absolute',
			content: '""',
			height: `${SLIDER_WIDTH}px`,
			width: `${SLIDER_WIDTH}px`,
			top: `-4px`,
			left: 0,
			'background-color': DefaultTheme.font.color.white,
			transition: '.4s',
			'border-radius': '50%',
			'box-shadow': DefaultTheme.shadow.box.dp2,
		},
	},
};
